import { runInAction, makeObservable, observable, computed, action } from 'mobx';
import bucketList from './BucketList';
import { erpApiurl } from '../stores/APIEndpoints';
import { PDFDocument } from 'pdf-lib';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Payments. The Service is unavailable. Please try after sometime." };

export default class PaymentSummaryStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    currentBranch = 'ALL BRANCHES'
    currentBranchID = 0;
    payments = [];
    filteredPayments = [];
    branchList = [
        {
            value: 0, label: 'All Branch'
        }
    ];
    bucketList = [
        {
            value: 0, label: 'All',

        }
    ];
    branchId = 0;
    totalPaidSum = 0;
    totalBillSum = 0;
    rowCount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;

        this.bucket = new bucketList();

        this.bucket.getDateData(this.bucketList);

        makeObservable(this, {
            state: observable,
            message: observable,
            payments: observable,
            rowCount: observable,
            filteredPayments: observable,
            totalPaidSum: observable,
            branchId: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchPayments: action,
            GetallBranchName: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    GetallBranchName = async () => {

        const payload = {
            BranchId: 0,
        }

        const reportUrl = `${erpApiurl}api/carbon/LTBranchDetails`;
        const response = await this.apiProxy.asyncPost(reportUrl, payload);
        const branches = await response.json();


        branches.map((branch) => {
            const branchVal = {
                value: branch.BranchId,
                label: branch.BranchName
            }

            this.branchList.push(branchVal)
        }
        );

    }

    filterBranch = (value, branch) => {

        this.currentBranch = branch;
        this.currentBranchID = value;

        this.fetchPayments();

    }

    filterBucket = (value1, value2) => {

        let payData = this.payments;

        if (value1 !== 'All') {
            payData = this.payments.filter((ele) => (ele.bucket >= value1 && ele.bucket <= value2));
        }

        this.totalPaidSum = payData.map(item => item.Payable).reduce((a, b) => a + b, 0);
        this.totalBillSum = payData.map(item => item.Total).reduce((a, b) => a + b, 0);

        this.rowCount = payData.length;

        this.filteredPayments = payData;
    }

    showSummary = async () => {

        const summaryheader = {
            number: this.currentBranchID,
            branch: this.currentBranch,
            collectionType: this.collectionType
        }

        const summary = {
            totalPaid: this.totalPaidSum,
            totalBill: this.totalBillSum
        }

        const payload = {
            header: summaryheader,
            items: this.filteredPayments,
            summary: summary
        }

        const reportUrl = `https://numedlabs.com/mailer/mailer/payments/reports/${this.currentBranchID}`;
        const response = await this.apiProxy.asyncPost(reportUrl, payload);
        const reportId = await response.text();

        if (reportId == this.currentBranchID) {
            return reportUrl;
        }

        console.log("Error in Creating Report");
        return "Error";
    }

    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchPayments = async () => {
        let url = "";
        if (this.collectionType == "Doctorwisedaily" || this.collectionType == "Doctorwisemonthly") {
            if (this.collectionType == "Doctorwisedaily") {
                this.collectionType = "daily";
            }
            else {
                this.collectionType = "monthly";
            }
            url = `${erpApiurl}api/carbon/GetIcSummaryDoctorWise?collectionType=${this.collectionType}`
        }
        else {
            url = `${erpApiurl}api/carbon/GetIcSummary?collectionType=${this.collectionType}&branchId=${this.currentBranchID}&Paidstatus=1`
        }

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            this.payments = data;
            this.filteredPayments = data;
            this.totalPaidSum = 0;
            this.totalBillSum = 0;
            for (let i = 0; i < data.length; i++) {
                const payment = data[i];
                this.totalPaidSum = this.totalPaidSum + payment.Payable;
                this.totalBillSum = this.totalBillSum + payment.Total;
            };
            this.rowCount = data.length;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    /** Fetch PDF URL for a single invoice */
        showInvoice = async (invoiceHeader) => {
            // console.log("Fetching invoice for paydetailstore:", invoiceHeader);
            try {
                // Fetch the invoice list for this invoice number
                const url = `${erpApiurl}api/carbon/GetIcInvoiceListByinvioce?invoiceno=${invoiceHeader.number}`;
                const data = await this.apiProxy.getAsync(url).then(r => r.json());
    
                if (!data || !data.length) return null;
    
                // Build summary
                const summary = { gross: 0, netDiscount: 0, net: 0 };
                data.forEach(item => summary.gross += item.IC);
                summary.net = summary.gross - summary.netDiscount;
    
                // Call mailer/report endpoint
                const payload = { header: invoiceHeader, items: data, summary };
                const reportUrl = `https://numedlabs.com/mailer/mailer/settlements/reports/${invoiceHeader.number}`;
                const resp = await this.apiProxy.asyncPost(reportUrl, payload);
                const reportId = await resp.text();
    
                if (reportId === invoiceHeader.number) return reportUrl;
    
            } catch (err) {
                console.error('Error fetching invoice', invoiceHeader, err);
            }
            return null;
        }
    
    
        /** Merge selected invoices into a single PDF (optimized API calls) */
        mergeInvoicesPdf = async (selectedRows) => {
            const mergedPdf = await PDFDocument.create();
            const failed = [];
    
            // Group rows by referrerId
            const rowsByReferrer = selectedRows.reduce((acc, row) => {
                if (!acc[row.ReferrerId]) acc[row.ReferrerId] = [];
                acc[row.ReferrerId].push(row);
                return acc;
            }, {});
    
            // Fetch all invoice numbers per referrer
            const invoiceNumbersByReferrer = {};
            for (const referrerId of Object.keys(rowsByReferrer)) {
                const anyRow = rowsByReferrer[referrerId][0];
                const invoiceNumbers = await this.fetchInvoiceNumbers(referrerId);
                invoiceNumbersByReferrer[referrerId] = invoiceNumbers;
            }
    
            const successfullyMerged = [];
            // Merge PDFs for each row
            for (const row of selectedRows) {
                try {
    
    
                    const invoiceNumbers = invoiceNumbersByReferrer[row.ReferrerId] || [];
                    const invoiceNumber = invoiceNumbers.shift() || row.Number; // get one invoice number and remove from list
    
                    // console.log("Merging invoice for row:", row.ReferrerId,  row.InvoiceNumber,invoiceNumbers,invoiceNumber);
                    const invoiceHeader = {
                        name: row.Doctorname,
                        number: invoiceNumber,
                        period: row.bucket
                    };
    
                    const url = await this.showInvoice(invoiceHeader);
                    if (!url) {
                        failed.push(invoiceHeader.number);
                        continue;
                    }
    
                    const pdfBytes = await fetch(url).then(res => res.arrayBuffer());
                    const pdf = await PDFDocument.load(pdfBytes);
                    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                    copiedPages.forEach(p => mergedPdf.addPage(p));
                    if (url) {
                        successfullyMerged.push(invoiceHeader);
    
                    }
    
                } catch (err) {
                    console.error("Error merging invoice:", err);
                    failed.push(row.InvoiceNumber || row.Number);
                }
            }
    
            if (mergedPdf.getPageCount() === 0) return null;
    
            // return new Blob([await mergedPdf.save()], { type: "application/pdf" });
            return { blob: new Blob([await mergedPdf.save()], { type: 'application/pdf' }), mergedInvoices: successfullyMerged };
        }
    
        UpdateMultipleIcPrintStatus = async (selectedInvoices) => {
            if (!selectedInvoices.length) return null;
            console.log("Updating multiple invoice statuses:", selectedInvoices);
            const updatePromises = selectedInvoices.map(invoice => {
                const payload = { invoiceno: invoice.number };
                const url = `${erpApiurl}api/Carbon/UpdateIcPrintStatus`;
                return this.apiProxy.asyncPost(url, payload)
                    .then(response => response.json())
                    .catch(e => {
                        console.error(`Failed to update status for ${invoice.number}`, e);
                        return null;
                    });
            });
    
            const results = await Promise.all(updatePromises);
            return results;
        };
    
        /** Fetch invoice numbers for a referrer & bucket (unprinted only) */
        fetchInvoiceNumbers = async (referrerId) => {
            const url = `${erpApiurl}api/carbon/GetInvioceSummary?ReferrerId=${referrerId}&collectionType=${this.collectionType}`;
            runInAction(() => { this.state = PENDING; this.message = ""; });
    
            try {
                const invoiceNumbers = await this.fetchByUrl(url);
                runInAction(() => { this.state = DONE; });
                return invoiceNumbers;
            } catch (error) {
                runInAction(() => {
                    this.state = ERROR;
                    this.message = "Failed to fetch payments";
                });
                console.error("fetchInvoiceNumbers error:", error);
                return [];
            }
        }
    
        /** Generic fetch helper (returns unprinted InvoiceNumbers array) */
        fetchByUrl = async (url) => {
            console.log('fetchByUrl'+url)
            try {
                const response = await this.apiProxy.getAsync(url);
                const data = await response.json();
                return Array.isArray(data)
                    ? data.filter(a => a.PrintStatus === 0).map(a => a.InvoiceNumber)
                    : [];
            } catch (error) {
                console.error("fetchByUrl error:", error);
                return [];
            }
        }


}
